export const API_COMMON_BASE_URL = process.env.NEXT_PUBLIC_APP_API_COMMON_URL;

export const API_SHOP_OPERATIONS_BASE_URL = process.env.NEXT_PUBLIC_APP_API_SHOP_OPERATIONS_URL;

export const UNAUTHORIZED_STATUS = 401;
